<template>
  <div class="course-detail">
    <div class="section-header">
      <i class="material-icons clickable" @click="$router.push('/courses')">arrow_back</i>
      <h1>{{activeLesson.title}}</h1>
      <div class="align-center">
        <i class="material-icons clickable hide-gt-xs" @click="menu = !menu">{{ menu ? 'close' : 'menu' }}</i>
        <i class="material-icons clickable" @click="note = !note">{{ note ? 'close' : 'note' }}</i>
      </div>
    </div>
    <div class="card card--course">
      <div class="side-bar" :class="{show: menu, hide: !menu}">
        <h2 style="text-align: center">Course Guide</h2>
        <div class="lesson-nav">
          <module-nav 
            v-for="(m, i) in course.modules" 
            :key="m.id"
            :courseModule="m" 
            :count="i + 1"
            class="small-top"
            :activeLesson="activeLesson"
            @lessonClicked="activateLesson"/>
        </div>
        <div>
          <!-- <h-progress :percent="percentComplete" /> -->
          <h-file :base64="false" @upload="file => fileUpload = file" v-if="showFileHandler" />
          <button class="btn btn--outline small-top btn--full" @click="complete">Complete</button>
        </div>
      </div>
      <div class="main-content flex" :class="{show: !menu, hide: menu}">
        <i class="material-icons clickable info-btn" @click="info = !info">info</i>
        <h-icon @click="fullScreen=!fullScreen" v-if="!fullScreen" class="full-screen-icon clickable">fullscreen</h-icon>
        <h-icon @click="fullScreen=!fullScreen" v-else class="full-screen-icon-exit clickable">fullscreen_exit</h-icon>

        <!-- <div> -->
        <main-content :lesson="activeLesson" :fullScreen="fullScreen"/>
          <!-- <h-file @upload="file => fileUpload = file" /> -->
          <button class="bottom-left btn btn--outline show-at-xs" @click="complete">Complete</button>
        <div v-if="note" class="additional-card">
          <h2>{{activeLesson.title}}'s notes</h2>
          <div class="divider" />
          <textarea v-model="activeLesson.note.text" placeholder="Write something..."/>
          <button class="btn btn--outline btn--full" @click="noteSave">Save</button>
        </div>

        <div v-if="info" class="additional-card">
          <i class="material-icons clickable info-btn" @click="info = !info">close</i>
          <h1>{{activeLesson.title}}</h1>
          <div>{{activeLesson.description}}</div>
          <div class="small-top" v-if="activeLesson.resources.length > 0">
            <h3>Additional Resources</h3>
            <div v-for="resource in activeLesson.resources" :key="resource.id">
              <a :href="resource.file || resource.url" target="_blank">{{resource.instruction}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
import moduleNav from "./moduleNav";
import mainContent from "./mainContent";
import snackbar from "@/services/hubs/snackbar";
import rewardHub from "@/services/hubs/raffle";
import hFile from "@/components/h-file";
import axios from "axios";
const CLIENT_EXERCISE_HISTORY_STORE = "ClientExercisesHistory";




export default {
  props: ["id"],
  components: { moduleNav, mainContent, hFile },
  data() {
    return {
      course: { modules: [] },
      userId: User.id,
      activeLesson: {},
      menu: false,
      note: false,
      newNote: {},
      info: false,
      fullScreen: false,
      fileUpload: undefined,
      showFileHandler: true
    };
  },
  methods: {
    complete() {
      let oldPercentComplete = this.percentComplete;
      snackbar.update("Saved");

      if (!this.activeLesson.completed || this.fileUpload) {
        let form = new FormData();
        form.append("exercise", this.activeLesson.id);
        form.append("completed", true);
        if (this.fileUpload) {
          form.append("file", this.fileUpload);
        }
        axios.post("/clients/exercise-history/", form);
        // clears out displayed file on exercise change
        this.showFileHandler = false;
        setTimeout(() => {
          this.showFileHandler = true;
        }, 0);
      }

      this.activeLesson.completed = true;
      if (this.percentComplete >= 100 && oldPercentComplete < 100) {
        this.$router.push("/courses");
        rewardHub.update("course");
        return;
      }
      let currentIndex = this.allLessons.findIndex((lesson) => this.activeLesson == lesson);
      if (currentIndex + 1 != this.allLessons.length) {
        this.activeLesson = this.allLessons[currentIndex + 1];
      }
      this.fileUpload = false;
      this.menu = false;
      rewardHub.update("lesson");
    },
    activateLesson(l) {
      this.activeLesson = l;
      this.menu = false;
    },
    noteSave() {
      snackbar.update("Saved");
      this.note = false;
      if (this.activeLesson.note.id) {
        dataStore.update("ClientNotes", this.activeLesson.note.id, {text: this.activeLesson.note.text}, { method: "patch" })
      } else {
        dataStore.create("ClientNotes", 
          {text: this.activeLesson.note.text, lesson: this.activeLesson.id, title: this.activeLesson.title}).then((note) => {
            this.activeLesson.note = note;
          })
      }
    }
  },
  created() {
    dataStore.find("ClientCourses", this.id).then(result => {
      this.course = result;
      this.activeLesson = this.incompleteLessons[0] || this.allLessons[0];
      if (this.$route.params.lesson) {
        let lesson = this.allLessons.find((lesson) => {
          return lesson.id == this.$route.params.lesson;
        });

        if (lesson) {
          this.activeLesson = lesson;
        }
      }
    });
  },
  watch: {
    activeLesson: function() {
      this.info = true;
    }
  },
  computed: {
    allLessons() {
      return this.course.modules
        .map(module => module.lessons)
        .reduce((allLessons, lessons) =>  [...allLessons, ...lessons], [])
    },
    incompleteLessons() {
      return this.allLessons.filter(l => !l.completed);
    },
    percentComplete() {
      return (this.allLessons.length - this.incompleteLessons.length) / (this.allLessons.length || 1) * 100; 
    }
  }
};
</script>

<style lang="less">
.card--course {
  height: 80vh;
  display: flex;
  flex-direction: row;

  .bottom {
    position: absolute;
    bottom: 5px;
    display: flex;
    flex-direction: row;
  }

  h2 {
    text-transform: none;
  }
  h3 {
    text-transform: none;
    font-family: 'Quicksand', sans-serif;
    font-size: 14px;
    letter-spacing: 1px;
  }

  .side-bar {
    height: 65vh;
    padding: 1em;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background-color: gray;
    color: white;
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: space-between;
    justify-content: space-between;

    .lesson-nav {
      height: 80%;
      overflow: auto;
    }
  }

  .main-content {
    align-items: center;
    background-color: rgba(125, 125, 125, .7);
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
    display: flex;
    height: 65vh;
    justify-content: center;
    position: relative;
    width: 75%;
    .media-container {
      width: 100%;
      height: 80%;
      display: flex;
      > * {
        width: 100%;
      }
    }
    .full-screen-icon {
      position: absolute;
      bottom: 5px;
      right: 5px;
      color: white;
      font-size: 35px;
    }
    .full-screen-icon-exit {
      position: fixed;
      bottom: 5px;
      right: 5px;
      color: white;
      font-size: 35px;
      z-index: 101;
    }

    .full-screen {
      position: fixed;
      top: 0;
      right: 0;
      width: 100vw;
      height: 100vh;
      z-index: 100;
    }

    .additional-card {
      height: 50%;
      width: 100%;
      overflow: auto;
      border-bottom-right-radius: 20px;
      position: absolute;
      background-color: rgba(125, 125, 125, .9);
      padding: 2em;
      bottom: 0px;
      color: white;
      a {
        color: white;
      }
      textarea {
        height: 60%;
        width: 100%;
      }
      textarea::placeholder {
        color: white;
      }
      @media (max-width: 600px) {
        border-radius: 20px;
        height: 100%;

        textarea {
          height: 80%;
        }
      }
    }

    .info-btn {
      position: absolute;
      top: 5px;
      right: 5px;
      color: white;
      font-size: 35px;
    }
  }
  @media (max-width: 600px) {
    .show {
      width: 100%;
      display: flex;
      border-radius: 20px;
    }

    .hide {
      display: none;
    }
  }
}
</style>
